import axios from 'axios';
import {AppSource} from './Config'
axios.interceptors.request.use(
  (config) => {
    // Do something before sending the request
    config.headers['x-app-source'] = AppSource.appSource
    // console.log('config', config);
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
// axios.interceptors.response.use(
//   (response) => {
//     // Do something with the response data
//     // console.log('Response received:', response);
//     return response;
//   },
//   (error) => {
//     // Do something with response error
//     return Promise.reject(error);
//   }
// );

export default axios;